
// import { useParams } from "react-router-dom";

// const PaymentHistory = () => {
    
// const {placementId, invoice} = useParams();

//   const body = {
//     page: 1,      
//     limit: 35,
//     placementId,
//     invoice,             
//   };


//   console.log("API Body", body);
//       return<>
//          <div>hello </div>
//       </>

// };

// export default PaymentHistory;
import React, { useEffect, useState } from "react";

import { useParams, useNavigate,useLocation} from "react-router-dom";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Pagination,
  TableContainer,
  Paper,
} from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';

// import { FaEdit } from "react-icons/fa";

import { Api } from "../webservices";

import Iconify from '../components/iconify';

const LIMIT = 35;

const PaymentHistory = () => {






const [openEdit, setOpenEdit] = useState(false);
const [selectedStatus, setSelectedStatus] = useState("");
const [paymentId, setPaymentId] = useState("");
 //  const [paymentHistoryId, setPaymentHistoryId] = useState("");








  const { placementId, invoice } = useParams();

  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  //  API CALL
//   const getPaymentHistory = (pageNo = 1) => {
//     const token = localStorage.getItem("token");

//     const body = {
//       page: pageNo,
//       limit: LIMIT,
//       placementId,
//       invoice,
//     };

//     Api("timeSheet/getPaymentHistory", "POST", body, token)
//       .then((response) => {
//         console.log("hello shyamlal====>>", response)
//          const apiData = response?.data?.data || [];
//         if (apiData.length > 0) {
//           const payments = apiData[0].payments || [];
//           setRows(payments);

//           setPaymentHistoryId(apiData[0]._id); 

//           const total = response.data.total || 1;
//           setTotalPages(Math.ceil(total / LIMIT));

//         } else {
//           setRows([]);
//           setTotalPages(1);
//         }
//       })
      





//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   };







  const getPaymentHistory = (pageNo = 1) => {
  const token = localStorage.getItem("token");

  const body = {
    page: pageNo,
    limit: LIMIT,
    placementId,
    invoice,
  };

  Api("timeSheet/getPaymentHistory", "POST", body, token)
    .then((response) => {
      console.log("hello shyamlal====>>", response);

     
      const resData = response?.data || {};
      const payments = resData?.payments || [];

      if (payments.length > 0) {
        setRows(payments);

        //  outer payment history id (if backend sends it)
        // if (resData._id) {
        //   setPaymentHistoryId(resData._id);
        // }

        const total = resData.count || 1;
        setTotalPages(Math.ceil(total / LIMIT));
      } else {
        setRows([]);
        setTotalPages(1);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      setRows([]);
      setTotalPages(1);
    });
};
















  const handleUpdateStatus = () => {
  const token = localStorage.getItem("token");

  const body = {
  //  "paymentHistoryId": paymentHistoryId, 
    "paymentId": paymentId,               
    "status": selectedStatus,             
  };

  Api("timeSheet/updatePaymentStatus", "POST", body, token)
    .then((res) => {

      //    console.log("hello shyamlalaluwu===>>>>>>", res);
      if (res.status === 200) {
        toast.success(res.data.message);
        setOpenEdit(false);
        getPaymentHistory(page); 
        toast.success();

      }
      else{
       // console.log("hello ");
           toast.success(res.data.message);
           toast.error();
      }
    })
    .catch((err) => console.error(err));
};



  const handleOpenEdit = (pId, status) => {
               setPaymentId(pId);
               setSelectedStatus(status);
               setOpenEdit(true);
     };



const handleDelete = (paymentId) => {


  const token = localStorage.getItem("token");

  const body = {
  
    "paymentId": paymentId,               
  };

  Api("timeSheet/delete_Payment_his", "POST", body, token)
    .then((res) => {
        console.log("shya=====>>>>>>>>>", res);
      if (res.status === 200) {
        getPaymentHistory(page); // table refresh
         toast.success(res.data.message);
      }
      else{
        toast.error(res.data.message);
        console.log("hello sh");
      }
    })
    .catch((err) => console.error(err));
};


  









  useEffect(() => {
    if (placementId && invoice) {
      getPaymentHistory(1);
    }
  }, [placementId, invoice]);


    const tablebg = 'rgba(82, 130, 190, 0.08)';

  //  PAGINATION CHANGE
  const handlePageChange = (event, value) => {
    setPage(value);
    getPaymentHistory(value);
  };

    const navigate = useNavigate();
     const location=useLocation();
     console.log("locationshamli===>>", location)



    const backFunctionNavigate=()=>{


      
      if(location.state?.valuee==="bench" || location.state?.valuee==="TimeSheet" || location.state?.valuee ===  "TimeSheet1"
        || location.state?.valuee==="PaymentHistory" || location.state?.valuee==="PaymentHistory1" || location.state?.valuee ===  "rec"
      ){
            navigate("/placement", {state:{valuee: location.state?.valuee}})
      }else{
                navigate(-1);
      }
  }



  return (
    <Box>
      {/* HEADER */} 
        <ToastContainer />

<Iconify icon="ion:arrow-back" fontSize={25} sx={{
        cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem',
        fontWeight: '600', mr: 1, mt: -1
      }} onClick={() => backFunctionNavigate()} />

      <Typography
        variant="h6"
         color="textSecondary"
        sx={{ mb: 1 }}
      >
        Payment History
      </Typography>

      {/* TABLE */} 
       <TableContainer component={Paper} sx={{ mt: 0.3 }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            // sx={{ backgroundColor: 'text.secondary' }}
             sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}
            >
            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Date</TableCell>
            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Details</TableCell>
            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Time Period</TableCell>
            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Amount</TableCell>
            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Status</TableCell>
            <TableCell sx={{ p: 1, py: 0.5, color: "white" }}>
  Action
</TableCell>

            <TableCell  sx={{ p: 1, py: 0.5, color: 'white' }}>Added</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.length > 0 ? (
            rows.map((row, index) => (
              <TableRow
                key={row._id}
                // sx={{
                //   backgroundColor: index % 2 === 0 ? "#E6ECF6" : "#FFFFFF",
                // }}


                sx={[
          {
            background: index % 2 === 0 ? 'text.background' : tablebg,
            '&:last-child td, &:last-child th': { border: 0 },
            '&:hover': { boxShadow: 5 },
          }
        ]}
                


              >
                <TableCell>
                  {new Date(row.date).toLocaleDateString()}
                </TableCell>

                <TableCell>{row.details}</TableCell>
                <TableCell>{row.timePeriod}</TableCell>
                {/* <TableCell>${row.amount}</TableCell>  */}
              
                <TableCell> {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${row.amount}`}</TableCell>
            
               <TableCell
              sx={{
                     color: row.status === "Paid" ? "green" : "red",
                      fontWeight: 600,
                      display: "flex",
                     alignItems: "center",
                   gap: 1,
  }}
>
  {row.status} 

  {/* {row.status === "Unpaid" && (
    <FaEdit
      style={{ cursor: "pointer" }}
      onClick={() =>
        handleOpenEdit(
          row._id,         
          row.status
        )
      }  
    />
  )}  */}
                        { row.status ==="Unpaid" &&(

                             <Iconify icon="bx:edit"
                                       sx={{ width: 15, height: 15 }}
                                       style={{ cursor: 'pointer' }} onClick={(e) => handleOpenEdit(row._id,row.status)}
                                     />

                        )
                                 
                        }
               </TableCell>



<TableCell> 
  <Button
    color="error"
    size="small"
    onClick={() => handleDelete(row._id)}
  >
    Delete
  </Button>
</TableCell>






                <TableCell>{row.addedBy}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No Payment History Found
              </TableCell>
            </TableRow>
            
          )}
        </TableBody>
      </Table>
</TableContainer>
      {/* PAGINATION – RIGHT SIDE */} 
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        {/* <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          shape="rounded"
          color="primary"
        /> */}
           {/* <Pagination count={totalPages} onChange={handlePageChange} variant="outlined" shape="rounded"/> */}
      </Box>


       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Edit Payment Status</DialogTitle>

  <DialogContent>
    <Select
      fullWidth
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
    >
      <MenuItem value="Paid">Paid</MenuItem>
      <MenuItem value="Unpaid">Unpaid</MenuItem>
    </Select>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
   <Button
  variant="contained"
  sx={{ backgroundColor: "#3C6BA5" }}
  onClick={handleUpdateStatus}
>
  Update
</Button>

  </DialogActions>
       </Dialog>
    </Box>
  );
};

export default PaymentHistory;
